<template>
  <div class="step-file">

    <validation-provider v-slot="{ validate, errors }" ref="provider" rules="required">
      <information-field
        name="recurrent-name"
        type="text"
        label="Nome"
        :required="true"
        v-model="form.name"
      />

      <information-field
        name="periodicity"
        type="select"
        label="Periodicidade"
        :required="true"
        v-model="form.periodicity"
        :options="periodicities"
      />

      <div class="form-group" :class="{ '-has-error': errors.length > 0 }">
        <label class="label" for="formFile">Arquivo</label>

        <input class="form-control
          block
          w-full
          p-3
          text-base
          font-normal
          text-gray-700
          bg-white bg-clip-padding
          border border-solid border-gray-300
          rounded
          transition
          ease-in-out
          m-0
          focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" type="file" id="formFile" @change="uploadFile" ref="file"
          accept="text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">

        <p class="description" v-if="errors.length > 0">{{ errors[0] }}</p>
      </div>

      <div class="form-group">
        <form
          class="form-group inline-block mr-3"
          :action="`/query/batch/download-csv-sample-file?token=${accessToken}` | apiLink"
          method="POST"
        >
          <button class="btn btn-success">
            <ion-icon name="download-outline"></ion-icon> Download arquivo CSV de exemplo
          </button>
          <input type="text" name="fields" :value="fieldsSampleFile" class="hidden">
          <input type="text" name="tag" :value="tag" class="hidden">
          <input type="text" name="template" :value="form.template.id" class="hidden">
        </form>
        <form
          class="form-group inline-block"
          :action="`/query/batch/download-excel-sample-file?token=${accessToken}` | apiLink"
          method="POST"
        >
          <button class="btn btn-success">
            <ion-icon name="download-outline"></ion-icon> Download arquivo Excel de exemplo
          </button>
          <input type="text" name="fields" :value="fieldsSampleFile" class="hidden">
          <input type="text" name="tag" :value="tag" class="hidden">
          <input type="text" name="template" :value="form.template.id" class="hidden">
        </form>
      </div>
    </validation-provider>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import { mapState } from 'vuex';
import newQueryFormFields from '@/compliance/mixins/newQueryFormFields';
import InformationField from '@/compliance/components/new-query/step-information/InformationField.vue';
import apiLink from '@/support/filters/apiLink';

export default {
  name: 'StepFile',

  props: {
    tag: {
      type: String,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
  },

  model: {
    prop: 'form',
    event: 'input',
  },

  mixins: [
    newQueryFormFields,
  ],

  filters: {
    apiLink,
  },

  data() {
    return {
    };
  },

  methods: {
    cleanSelections() {
      this.$emit('input', {
        ...this.form,
        consultations: [],
        template: [],
      });
    },
    async uploadFile(e) {
      const { valid } = await this.$refs.provider.validate(e);

      if (valid) {
        [this.form.file] = this.$refs.file.files;
      }
    },
  },

  computed: {
    ...mapState('template', {
      template: 'template',
    }),
    ...mapState('auth', {
      accessToken: 'accessToken',
    }),
    ...mapState('recurrent', {
      periodicities: 'periodicities',
    }),
    fieldsSampleFile() {
      return this.sharedFields.map((field) => field.name).join(';');
    },
  },

  components: {
    ValidationProvider,
    InformationField,
  },
};
</script>

<style scoped>
  .-has-error > input[type="file"] {
    @apply border-red-500;
  }
</style>
